import { config } from '@shakkerai/config';
import { translate } from '@shakkerai/util-i18n';

const isOverseas = config.env === 'aws';
const envName = config.name;

export const MODEL_SD15 = 1;
export const MODEL_SD21 = 2;
export const MODEL_SDXL = 3;
export const MODEL_SD30 = 7;
export const MODEL_PONY = 10;
export const MODEL_PIXART_E = 9;
export const MODEL_HUNYUAN = 8;
export const MODEL_HUNYUAN_11 = 12;
export const MODEL_HUNYUAN_12 = 8;
export const MODEL_KOLORS = 11;
export const MODEL_FLUX = 19;
export const MODEL_SD35 = 21;
export const MODEL_SD35M = 20;
export const MODEL_ILLUS = 22;

export const SDXL_MODELS_FAMILY = {
  [MODEL_SDXL]: true,
  [MODEL_PONY]: true,
  [MODEL_KOLORS]: true,
  [MODEL_ILLUS]: true,
};

export const SD3_MODELS_FAMILY = {
  [MODEL_SD30]: true,
  [MODEL_SD35]: true,
  [MODEL_SD35M]: true,
  [MODEL_PIXART_E]: true,
  [MODEL_HUNYUAN_11]: true,
  [MODEL_HUNYUAN_12]: true,
  [MODEL_FLUX]: true,
};

export const BASETYPE_VALUE_TO_LABEL = {
  [MODEL_SD15]: translate('model_sd15'),
  [MODEL_SD21]: translate('model_sd21'),
  [MODEL_SDXL]: translate('model_sdxl'),
  [MODEL_SD30]: translate('model_sd30'),
  [MODEL_SD35]: translate('model_sd35'),
  [MODEL_SD35M]: translate('model_sd35M'),
  [MODEL_FLUX]: translate('model_flux'),
  [MODEL_PONY]: translate('model_pony'),
  [MODEL_PIXART_E]: translate('model_pixart_e'),
  [MODEL_HUNYUAN_11]: translate('model_hunyuan_11'),
  [MODEL_HUNYUAN_12]: translate('model_hunyuan_12'),
  [MODEL_KOLORS]: translate('model_kolors'),
  [MODEL_ILLUS]: 'Illustrious',
};

export const modelTypeMap = {
  checkpoint: '1',
  lora: '5',
};

export const modelTypeLabelsMap = {
  1: 'checkpoint',
  5: 'lora',
};

export const BASETYPE_VALUE_TO_SHORT_LABEL = {
  [MODEL_SD15]: 'SD 1.5',
  [MODEL_SD21]: 'SD 2.1',
  [MODEL_SDXL]: 'SD XL',
  [MODEL_SD30]: 'SD 3.0',
  [MODEL_SD35]: 'SD 3.5L',
  [MODEL_SD35M]: 'SD 3.5M',
  [MODEL_FLUX]: 'F.1',
  [MODEL_PONY]: translate('model_pony'),
  [MODEL_PIXART_E]: translate('model_pixart_e'),
  [MODEL_HUNYUAN_11]: translate('model_hunyuan_11'),
  [MODEL_HUNYUAN_12]: translate('model_hunyuan_12'),
  [MODEL_KOLORS]: translate('model_kolors'),
  [MODEL_ILLUS]: 'Illustrious',
};

export const BASETYPES_FILTER_OPTIONS = [
  { label: BASETYPE_VALUE_TO_LABEL[MODEL_FLUX], value: MODEL_FLUX },
  { label: BASETYPE_VALUE_TO_LABEL[MODEL_SDXL], value: MODEL_SDXL },
  {
    label: translate('model_others'),
    items: [
      { label: BASETYPE_VALUE_TO_LABEL[MODEL_SD35], value: MODEL_SD35 },
      { label: BASETYPE_VALUE_TO_LABEL[MODEL_SD15], value: MODEL_SD15 },
      { label: BASETYPE_VALUE_TO_LABEL[MODEL_PONY], value: MODEL_PONY },
      { label: BASETYPE_VALUE_TO_LABEL[MODEL_KOLORS], value: MODEL_KOLORS },
      { label: BASETYPE_VALUE_TO_LABEL[MODEL_SD30], value: MODEL_SD30 },
      { label: BASETYPE_VALUE_TO_LABEL[MODEL_ILLUS], value: MODEL_ILLUS },
      { label: BASETYPE_VALUE_TO_LABEL[MODEL_HUNYUAN_11], value: MODEL_HUNYUAN_11 },
      { label: BASETYPE_VALUE_TO_LABEL[MODEL_HUNYUAN_12], value: MODEL_HUNYUAN_12 },
      { label: BASETYPE_VALUE_TO_LABEL[MODEL_PIXART_E], value: MODEL_PIXART_E },
      { label: BASETYPE_VALUE_TO_LABEL[MODEL_SD35M], value: MODEL_SD35M },
    ],
  },
];

export const BASETYPE_VALUE_TO_NAME = {
  [MODEL_SD15]: 'SD 1.5',
  [MODEL_SD21]: 'SD 2.1',
  [MODEL_SDXL]: 'SD XL',
  [MODEL_SD30]: 'SD 3.0',
  [MODEL_SD35]: 'SD 3.5L',
  [MODEL_SD35M]: 'SD 3.5M',
  [MODEL_FLUX]: 'FLUX.1',
  [MODEL_PONY]: 'Pony',
  [MODEL_PIXART_E]: 'PixArt Σ',
  [MODEL_HUNYUAN_11]: 'Hunyuan 1.1',
  [MODEL_HUNYUAN_12]: 'Hunyuan 1.2',
  [MODEL_KOLORS]: 'Kolors',
  [MODEL_ILLUS]: 'Illustrious',
};

export const BASETYPE_NAME_TO_VALUE = {
  'SD 1.5': MODEL_SD15,
  'SD 2.1': MODEL_SD21,
  'SD XL': MODEL_SDXL,
  'SD 3.0': MODEL_SD30,
  'SD 3': MODEL_SD30,
  'SD 3.5': MODEL_SD35,
  'SD 3.5L': MODEL_SD35,
  'SD 3.5M': MODEL_SD35M,
  Flux: MODEL_FLUX,
  'FLUX.1': MODEL_FLUX,
  'F.1': MODEL_FLUX,
  Pony: MODEL_PONY,
  Hunyuan: MODEL_HUNYUAN_12,
  'PixArt Σ': MODEL_PIXART_E,
  'Hunyuan DiT v1.2': MODEL_HUNYUAN_12,
  'Hunyuan DiT v1.1': MODEL_HUNYUAN_11,
  'Hunyuan 1.1': MODEL_HUNYUAN_11,
  'Hunyuan 1.2': MODEL_HUNYUAN_12,
  Kolors: MODEL_KOLORS,
  Illustrious: MODEL_ILLUS,
};

export const BASETYPE_NAME_TO_LABEL = {
  [BASETYPE_VALUE_TO_NAME[MODEL_SD15]]: translate('model_sd15'),
  [BASETYPE_VALUE_TO_NAME[MODEL_SD21]]: translate('model_sd21'),
  [BASETYPE_VALUE_TO_NAME[MODEL_SDXL]]: translate('model_sdxl'),
  [BASETYPE_VALUE_TO_NAME[MODEL_SD30]]: translate('model_sd30'),
  [BASETYPE_VALUE_TO_NAME[MODEL_SD35]]: translate('model_sd35'),
  [BASETYPE_VALUE_TO_NAME[MODEL_SD35M]]: translate('model_sd35M'),
  [BASETYPE_VALUE_TO_NAME[MODEL_FLUX]]: translate('model_flux'),
  [BASETYPE_VALUE_TO_NAME[MODEL_PONY]]: translate('model_pony'),
  [BASETYPE_VALUE_TO_NAME[MODEL_PIXART_E]]: translate('model_pixart_e'),
  [BASETYPE_VALUE_TO_NAME[MODEL_HUNYUAN_11]]: translate('model_hunyuan_11'),
  [BASETYPE_VALUE_TO_NAME[MODEL_HUNYUAN_12]]: translate('model_hunyuan_12'),
  [BASETYPE_VALUE_TO_NAME[MODEL_KOLORS]]: translate('model_kolors'),
  [BASETYPE_VALUE_TO_NAME[MODEL_ILLUS]]: 'Illustrious',
};

export const BASETYPE_NAME_TO_SHORT_LABEL = {
  [BASETYPE_VALUE_TO_NAME[MODEL_SD15]]: translate('model_sd15_short'),
  [BASETYPE_VALUE_TO_NAME[MODEL_SD21]]: translate('model_sd21'),
  [BASETYPE_VALUE_TO_NAME[MODEL_SDXL]]: translate('model_sdxl_short'),
  [BASETYPE_VALUE_TO_NAME[MODEL_SD30]]: translate('model_sd30'),
  [BASETYPE_VALUE_TO_NAME[MODEL_SD35]]: translate('model_sd35_short'),
  [BASETYPE_VALUE_TO_NAME[MODEL_SD35M]]: translate('model_sd35M_short'),
  [BASETYPE_VALUE_TO_NAME[MODEL_FLUX]]: translate('model_flux_short'),
  [BASETYPE_VALUE_TO_NAME[MODEL_PONY]]: translate('model_pony'),
  [BASETYPE_VALUE_TO_NAME[MODEL_PIXART_E]]: translate('model_pixart_e'),
  [BASETYPE_VALUE_TO_NAME[MODEL_HUNYUAN_11]]: translate('model_hunyuan_11'),
  [BASETYPE_VALUE_TO_NAME[MODEL_HUNYUAN_12]]: translate('model_hunyuan_12'),
  [BASETYPE_VALUE_TO_NAME[MODEL_KOLORS]]: translate('model_kolors'),
  [BASETYPE_VALUE_TO_NAME[MODEL_ILLUS]]: 'Illustrious',
};

export const fallbackModelBaseParams = {
  [MODEL_SD15]: {
    versionId: 22686,
    shakkerVersionId: 1455799,
    samplerMethod: '15',
    samplingSteps: 30,
    cfgScale: 7,
    width: 768,
    height: 1024,
    clipSkip: 2,
    ngPrompt:
      'nsfw,EasyNegative, EasyNegativeV2, ng_deepnegative_v1_75t, worst quality, low quality,bad-hands-5,BadHandsV5',
  },
  [MODEL_SD21]: {
    versionId: 22687,
    shakkerVersionId: 27462,
    samplerMethod: '15',
    samplingSteps: 30,
    cfgScale: 7,
    width: 768,
    height: 1024,
    clipSkip: 2,
    ngPrompt:
      'nsfw,EasyNegative, EasyNegativeV2, ng_deepnegative_v1_75t, worst quality, low quality,bad-hands-5,BadHandsV5',
  },
  [MODEL_SDXL]: {
    versionId: 26968,
    shakkerVersionId: 1488890,
    samplerMethod: '15',
    samplingSteps: 30,
    cfgScale: 7,
    width: 768,
    height: 1024,
    clipSkip: 2,
    ngPrompt: 'lowres, normal quality, worst quality, cropped, blurry, drawing, painting, glowing,nsfw',
  },
  [MODEL_ILLUS]: {
    versionId: 2728592,
    shakkerVersionId: 2814745,
    samplerMethod: '15',
    samplingSteps: 20,
    cfgScale: 7,
    width: 768,
    height: 1024,
    clipSkip: 2,
    ngPrompt: 'lowres, normal quality, worst quality, cropped, blurry, drawing, painting, glowing,nsfw',
  },
  [MODEL_SD30]: {
    versionId: 1882271,
    shakkerVersionId: 1489596,
    samplerMethod: '31',
    samplingSteps: 28,
    cfgScale: 4.5,
    width: 768,
    height: 1024,
    clipSkip: 2,
    ngPrompt:
      'bad quality, poor quality, doll, disfigured, jpg, toy, bad anatomy, missing limbs, missing fingers, 3d, cgi',
  },
  [MODEL_SD35]: {
    versionId: 1882271,
    shakkerVersionId: 1489596,
    samplerMethod: '7',
    samplingSteps: 28,
    cfgScale: 4,
    width: 1024,
    height: 1024,
    clipSkip: 2,
    ngPrompt:
      'bad quality, poor quality, doll, disfigured, jpg, toy, bad anatomy, missing limbs, missing fingers, 3d, cgi',
  },
  [MODEL_SD35M]: {
    versionId: 2877768,
    shakkerVersionId: 2844272,
    samplerMethod: '7',
    samplingSteps: 28,
    cfgScale: 4,
    width: 1024,
    height: 1024,
    clipSkip: 2,
    ngPrompt: '',
  },
  [MODEL_PONY]: {
    versionId: 1623774,
    shakkerVersionId: 1492494,
    samplerMethod: '15',
    samplingSteps: 30,
    cfgScale: 7,
    width: 768,
    height: 1024,
    clipSkip: 2,
    ngPrompt: 'lowres, normal quality, worst quality, cropped, blurry, drawing, painting, glowing,nsfw',
  },
  [MODEL_PIXART_E]: {
    versionId: 1896296,
    shakkerVersionId: 1489799,
    samplerMethod: '7', // DPM++ 2M
    samplingSteps: 28,
    cfgScale: 5,
    width: 768,
    height: 1024,
    clipSkip: 2,
    ngPrompt: 'lowres, normal quality, worst quality, cropped, blurry, drawing, painting, glowing,nsfw',
  },
  [MODEL_HUNYUAN_11]: {
    versionId: 2179271,
    shakkerVersionId: 0,
    samplerMethod: '15',
    samplingSteps: 30,
    cfgScale: 7,
    width: 768,
    height: 1024,
    clipSkip: 2,
    ngPrompt:
      'nsfw,EasyNegative, EasyNegativeV2, ng_deepnegative_v1_75t, worst quality, low quality,bad-hands-5,BadHandsV5',
  },
  [MODEL_HUNYUAN_12]: {
    versionId: 2063446,
    shakkerVersionId: 1499004,
    samplerMethod: '0', // Euler a
    samplingSteps: 28,
    cfgScale: 4.5,
    width: 768,
    height: 1024,
    clipSkip: 2,
    ngPrompt:
      'bad quality, poor quality, doll, disfigured, jpg, toy, bad anatomy, missing limbs, missing fingers, 3d, cgi',
  },
  [MODEL_KOLORS]: {
    versionId: 2179271,
    shakkerVersionId: 1501689,
    samplerMethod: '15',
    samplingSteps: 40,
    cfgScale: 7,
    width: 768,
    height: 1024,
    clipSkip: 2,
    ngPrompt: 'lowres, normal quality, worst quality, cropped, blurry, drawing, painting, glowing,nsfw',
  },
  [MODEL_FLUX]: {
    versionId: 2295774,
    shakkerVersionId: 1508012,
    samplerMethod: '1',
    samplingSteps: 30,
    cfgScale: 30,
    width: 1024,
    height: 1024,
    clipSkip: 2,
    ngPrompt:
      'bad quality, poor quality, doll, disfigured, jpg, toy, bad anatomy, missing limbs, missing fingers, 3d, cgi',
  },
};

export const communityUrl = isOverseas ? 'https://www.shakker.ai' : 'https://www.liblib.art';

export const outpaintSizeOptions = [
  {
    id: 1,
    width: 1,
    height: 1,
    value: '1.00',
  },
  {
    id: 2,
    width: 3,
    height: 2,
    value: '1.50',
  },
  {
    id: 3,
    width: 4,
    height: 3,
    value: '1.33',
  },
  {
    id: 7,
    width: 16,
    height: 9,
    value: '1.78',
  },
  {
    id: 5,
    width: 2,
    height: 3,
    value: '0.67',
  },
  {
    id: 6,
    width: 3,
    height: 4,
    value: '0.75',
  },
  {
    id: 4,
    width: 9,
    height: 16,
    value: '0.56',
  },
];

export const outpaintPresetModels = [
  {
    label: translate('inpaint_style_realistic'),
    key: 'realistic',
    moduleId: isOverseas ? 1792087 : 20999,
    modelVersionId: isOverseas ? 1496033 : 27161,
  },
  {
    label: translate('simplemode_landing_case5'),
    key: 'landing',
    moduleId: isOverseas ? 1071270 : 1071270,
    modelVersionId: isOverseas ? 1087436 : 1087436,
  },
];

export const inpaintPresetModels = [
  {
    label: translate('inpaint_style_original'), //'原图风格',
    key: 'original',
  },
  {
    label: translate('inpaint_style_custom'), //'自定义',
    key: 'custom',
  },
  {
    label: translate('inpaint_style_realistic'), //'通用',
    key: 'common',
    modelName: 'DreamShaper XL1.0',
    libLink: 'https://www.liblib.art/modelinfo/4f9d68642b024d0aa0cdcafb0052af89',
    modelId: 20999,
    modelUuid: '4f9d68642b024d0aa0cdcafb0052af89',
    versionId: 27162,
    versionuuid: '686b30e67ee7489abfdb5d37e30a0f04',
    vae: 'automatic',
    vaeValue: '',
    samplerMethod: 'DPM++ 2M Karras',
    sampleMethodValue: '15',
    shakkerLink: 'https://www.shakker.ai/modelinfo/431d35105d0a4e26acf8e3fa8dabdc68',
    shakkerModelId: 1478177,
    shakkerModelUuid: '431d35105d0a4e26acf8e3fa8dabdc68',
    shakkerVersionId: 1485131,
    shakkerVersionUuid: '874c12afe5b04a41ad59137e24730739',
    value: isOverseas ? 1485131 : 27162,
  },
  {
    label: translate('inpaint_style_photography'), //真实摄影
    key: 'photography',
    modelName: 'LEOSAM HelloWorld 新世界 | SDXL 大模型',
    libLink: 'https://www.liblib.art/modelinfo/506c46c91b294710940bd4b183f3ecd7',
    modelId: 24413,
    modelUuid: '506c46c91b294710940bd4b183f3ecd7',
    versionId: 1454929,
    versionuuid: '0a36822043c14404b427805cecd61ec0',
    vae: 'automatic',
    vaeValue: '',
    samplerMethod: 'DPM++ 2M Karras',
    sampleMethodValue: '15',
    shakkerLink: 'https://www.shakker.ai/modelinfo/506c46c91b294710940bd4b183f3ecd7',
    shakkerModelId: 24413,
    shakkerModelUuid: '506c46c91b294710940bd4b183f3ecd7',
    shakkerVersionId: 1024297,
    shakkerVersionUuid: 'b758c32a70fa4e95a055211418d274cf',
    value: isOverseas ? 1024297 : 1454929,
  },
  {
    label: translate('inpaint_style_anime'), //二次元
    key: 'anime',
    modelName: 'Normal anime_XL',
    libLink: '20d280af923846bfa436cd759883d7ef',
    modelId: 1831734,
    modelUuid: '20d280af923846bfa436cd759883d7ef',
    versionId: 1853033,
    versionuuid: '2b39519a44ff4ea99a69d5c0477c654a',
    vae: 'automatic',
    vaeValue: '',
    samplerMethod: 'DPM++ 2M Karras',
    sampleMethodValue: '15',
    shakkerLink: 'https://www.shakker.ai/modelinfo/20d280af923846bfa436cd759883d7ef',
    shakkerModelId: 1792171,
    shakkerModelUuid: '20d280af923846bfa436cd759883d7ef',
    shakkerVersionId: 1489127,
    shakkerVersionUuid: '2b39519a44ff4ea99a69d5c0477c654a',
    value: isOverseas ? 1489127 : 1853033,
  },
  {
    label: translate('inpaint_style_illustration'), //艺术插画
    key: 'illustration',
    modelName: 'LEOSAM AIArt 兔狲插画 SDXL 大模型',
    libLink: 'https://www.liblib.art/modelinfo/b2abe174c89940cb90cc4b02d1a5bbc6',
    modelId: 347406,
    modelUuid: 'b2abe174c89940cb90cc4b02d1a5bbc6',
    versionId: 481980,
    versionuuid: 'f622ceb656c348ce9b08729d8fc2ae42',
    vae: 'automatic',
    vaeValue: '',
    samplerMethod: 'DPM++ 2M Karras',
    sampleMethodValue: '15',
    shakkerLink: 'https://www.shakker.ai/modelinfo/b2abe174c89940cb90cc4b02d1a5bbc6',
    shakkerModelId: 347406,
    shakkerModelUuid: 'b2abe174c89940cb90cc4b02d1a5bbc6',
    shakkerVersionId: 481980,
    shakkerVersionUuid: 'f622ceb656c348ce9b08729d8fc2ae42',
    value: 481980,
  },
  {
    label: translate('inpaint_style_3d'), //3D 立体
    key: '3d',
    modelName: 'Samaritan 3d Cartoon',
    libLink: 'https://www.liblib.art/modelinfo/6228adb132b149e29ae046ccd01e5612',
    modelId: 141723,
    modelUuid: '6228adb132b149e29ae046ccd01e5612',
    versionId: 151367,
    versionuuid: '613809f646f2402c8cdd5954644f0896',
    vae: 'automatic',
    vaeValue: '',
    samplerMethod: 'DPM++ 2M Karras',
    sampleMethodValue: '15',
    shakkerLink: 'https://www.shakker.ai/modelinfo/16bdb19c4f934ec28eb51c6ea1e27fbf',
    shakkerModelId: 174768,
    shakkerModelUuid: '16bdb19c4f934ec28eb51c6ea1e27fbf',
    shakkerVersionId: 1485678,
    shakkerVersionUuid: '5dd25811e23f494e907b0f23aa0346b6',
    value: isOverseas ? 1485678 : 151367,
  },
  {
    label: translate('inpaint_style_cg'), //游戏 CG
    key: 'game_cg',
    modelName: 'DreamShaper XL1.0',
    libLink: 'https://www.liblib.art/modelinfo/4f9d68642b024d0aa0cdcafb0052af89',
    modelId: 20999,
    modelUuid: '4f9d68642b024d0aa0cdcafb0052af89',
    versionId: 27162,
    versionuuid: '686b30e67ee7489abfdb5d37e30a0f04',
    vae: 'automatic',
    vaeValue: '',
    samplerMethod: 'DPM++ 2M Karras',
    sampleMethodValue: '15',
    shakkerLink: 'https://www.shakker.ai/modelinfo/431d35105d0a4e26acf8e3fa8dabdc68',
    shakkerModelId: 1478177,
    shakkerModelUuid: '431d35105d0a4e26acf8e3fa8dabdc68',
    shakkerVersionId: 1485131,
    shakkerVersionUuid: '874c12afe5b04a41ad59137e24730739',
    value: isOverseas ? 1485131 : 27162,
  },
];

const inpaintCustomModelParams = {
  liblib: {
    versionIdInpaint: 18532056,
  },
  shakker: {
    versionIdInpaint: 1518196,
  },
};
export const inpaintCustomModelParam = isOverseas ? inpaintCustomModelParams.shakker : inpaintCustomModelParams.liblib;

export const inpaintPresetModelsMap = Object.fromEntries(inpaintPresetModels.map((item) => [item.key, item]));

export const outpaintPresetModelsMap = Object.fromEntries(outpaintPresetModels.map((item) => [item.key, item]));

export const defaultInpaintModelKey = inpaintPresetModels[0].key;

export const defaultOutpaintModelKey = outpaintPresetModels[0].key;

const _presetCheckpoints = {
  shakker: [
    {
      id: 'base_checkpoint',
      displayName: 'Shakker Zeno-1',
      imageBanner:
        'https://models-online-persist.shakker.cloud/img/cfb217906693401bb83bfe09f6b48823/58680a393784760d7f884a3a7e7141561bac006c11338db3cc0189d604c6d2be.png',
      imageVertical:
        'https://models-online-persist.shakker.cloud/img/cfb217906693401bb83bfe09f6b48823/e07ea478497166b7c2e904350e814ef3d8e42d0415bbc18fd43634eec07c656b.png',
      imageIcon:
        'https://models-online-persist.shakker.cloud/img/cfb217906693401bb83bfe09f6b48823/e9f00e6f8594ac188effa4816ac6df61e1e9718dac3b91deccf3576b5e6feea0.png',
      imageUrl:
        'https://models-online-persist.shakker.cloud/img/cfb217906693401bb83bfe09f6b48823/c1efca0d684145d708dd975b571b78211494fe7c4e51c81de1b1ed1a24a1093e.png',
      versionDetail: {
        name: 'Star-3',
        baseType: 'FLUX.1',
        modelId: 1807379,
        modelType: 'checkpoint',
        modelUuid: '78c20902aea8460da70ff4a89186000c',
        samplingSteps: 30,
        versionId: 1508012,
        versionIdInpaint: 1518196,
        uuid: 'bb5ddad75aaa4af68d864c5fb1456601',
      },
    },
    {
      id: 'base_checkpoint_sd35',
      displayName: 'Default Model SD3.5',
      imageUrl:
        'https://models-online-persist.shakker.cloud/img/cfb217906693401bb83bfe09f6b48823/9b826de9cf6fe7eb96d861ddf2f51dd6c54c29835236cc0770a5f19ad6140933.png',
      versionDetail: {
        name: 'sd3.5large',
        baseType: 'SD 3.5L',
        modelId: 2791503,
        samplingSteps: 28,
        modelType: 'checkpoint',
        modelUuid: '1fd080e1f6b44e57a9299375545b5906',
        versionId: 2820391,
        uuid: 'd494b531a9394e85b13d4f1f8b7e0f77',
        samplerMethod: '7',
      },
    },
    {
      id: 'portrait',
      displayName: 'Portrait Flux',
      imageUrl:
        'https://models-online-persist.shakker.cloud/img/94c944b4511046f3985a237724cb7ce8/8730aa5848d719d6060871da36bc3385688475999f006ae4cfca1871cb165a92.png',
      versionDetail: {
        name: 'AWPortrait FL',
        baseType: 'FLUX.1',
        modelId: 1824060,
        modelType: 'checkpoint',
        modelUuid: 'baa0dc46adb34547860a17a571065c9d',
        versionId: 1527737,
        versionIdInpaint: 1518196,
        uuid: '287ef6222ae14d089bff7a2a7c4b6a9b',
        samplerMethod: '1',
      },
    },
    {
      id: 'base_checkpoint_xl',
      displayName: 'Default Model XL',
      imageUrl:
        'https://models-online-persist.shakker.cloud/img/94c944b4511046f3985a237724cb7ce8/84491ee4698c4fbed2dbe654ff98dcdb9e9daef4d0fe3bc03697c392e1cab92e.jpeg',
      versionDetail: {
        name: 'DreamShaper XL1.0',
        baseType: 'SD XL',
        modelId: 1792087,
        modelType: 'checkpoint',
        modelUuid: '042389545b3d48a9b48c70197642e502',
        versionId: 1488890,
        uuid: '250442a1fcc342bea2b1d20870583d23',
        samplerMethod: '15',
      },
    },
    {
      id: 'photography',
      displayName: 'Photography XL',
      imageUrl:
        'https://models-online-persist.shakker.cloud/img/94c944b4511046f3985a237724cb7ce8/01edd55df1c9c3983741efa6da9b9ae7933b33ab456863c1b5fd3c1c947a7cb6.png',
      versionDetail: {
        name: 'LEOSAM HelloWorld SDXL',
        baseType: 'SD XL',
        modelId: 24413,
        modelType: 'checkpoint',
        modelUuid: '506c46c91b294710940bd4b183f3ecd7',
        versionId: 1489700,
        uuid: 'aeed3bb1cdcb40c098e6f5011aa6d5cb',
      },
    },
    {
      id: 'anime',
      displayName: 'Anime XL',
      imageUrl:
        'https://models-online-persist.shakker.cloud/img/94c944b4511046f3985a237724cb7ce8/e609c59ace633dd8c58f79acba876c63a6aeb4af582b7d4ead18b889f5ced001.png',
      versionDetail: {
        name: 'Normal anime_XL',
        baseType: 'SD XL',
        modelId: 1792171,
        modelType: 'checkpoint',
        modelUuid: '20d280af923846bfa436cd759883d7ef',
        versionId: 1489127,
        uuid: '2b39519a44ff4ea99a69d5c0477c654a',
        vae: '',
        samplerMethod: '15',
      },
    },
    {
      id: 'illustration',
      displayName: 'Illustration XL',
      imageUrl:
        'https://models-online-persist.shakker.cloud/img/94c944b4511046f3985a237724cb7ce8/89cafd4e1d4fa7e2f05f546ba24f69a264b6b4547adedbb5c79d9943051ae064.png',
      versionDetail: {
        name: 'LEOSAM AIArt 兔狲插画 SDXL大模型',
        baseType: 'SD XL',
        modelId: 347406,
        modelType: 'checkpoint',
        modelUuid: 'b2abe174c89940cb90cc4b02d1a5bbc6',
        versionId: 481980,
        uuid: 'f622ceb656c348ce9b08729d8fc2ae42',
        vae: '',
        samplerMethod: '15',
      },
    },
    {
      id: '3d',
      displayName: '3D Art XL',
      imageUrl:
        'https://models-online-persist.shakker.cloud/img/94c944b4511046f3985a237724cb7ce8/0da97b1fff05a90828d129d065b8915b1c31c21579143231f1cf4780f339add1.png',
      versionDetail: {
        name: 'Samaritan 3d Cartoon',
        baseType: 'SD XL',
        modelId: 174768,
        modelType: 'checkpoint',
        modelUuid: '16bdb19c4f934ec28eb51c6ea1e27fbf',
        versionId: 1485678,
        uuid: '5dd25811e23f494e907b0f23aa0346b6',
        vae: '',
        samplerMethod: '15',
      },
    },
    {
      id: 'architecture',
      displayName: 'Arch & Interiors XL',
      imageUrl:
        'https://models-online-persist.shakker.cloud/img/94c944b4511046f3985a237724cb7ce8/e1bf35dd8f72cbafeeb44003c13a369660972980a3a41dd52741b6937f69f694.png',
      versionDetail: {
        name: '老王_archi_XL',
        baseType: 'SD XL',
        modelId: 1460709,
        modelType: 'checkpoint',
        modelUuid: '8ca144d887554751ad0e16dc9c9e1323',
        versionId: 1483235,
        uuid: 'baf100e5eb314234baa9701ebffa2539',
        vae: '',
        samplerMethod: '15',
      },
    },
    {
      id: 'ecommerce',
      displayName: 'Mockups XL',
      imageUrl:
        'https://models-online-persist.shakker.cloud/img/94c944b4511046f3985a237724cb7ce8/4c18b3c5c09aed2c2f462262a68d511bd0e346722cd80cab1e6fe8ad06e3dd4b.png',
      versionDetail: {
        name: 'Product Realism | FLIX Simple and True',
        baseType: 'FLUX.1',
        modelId: 1816571,
        modelType: 'checkpoint',
        modelUuid: '7a8ac5d326f24e04b887abc90e59ffa3',
        versionId: 1519772,
        uuid: '482888bc17374beda48b74532cf74668',
        vae: '',
        samplerMethod: '0',
      },
    },
  ],
  liblib: [
    {
      id: 'base_checkpoint',
      displayName: '星流 Star-3 Alpha',
      imageBanner:
        'https://liblibai-online.liblib.cloud/img/3158b1962c5b4c2e8e8a86f65bd533c6/082a12a33a725650959c049d1258cb6ec6756be4d385f32457f4fcc8b289806a.png',
      imageVertical:
        'https://liblibai-online.liblib.cloud/img/3158b1962c5b4c2e8e8a86f65bd533c6/2208db2f837133a8c940448af5be0b7e5f78a57a7855058780b1966885d8503c.png',
      imageUrl:
        'https://liblibai-online.liblib.cloud/img/3158b1962c5b4c2e8e8a86f65bd533c6/bf9f7859681046b1f279b7eb1c5da01a048a1b66062b0dc3953ebc9aede28076.png',
      imageIcon:
        'https://liblibai-online.liblib.cloud/img/3158b1962c5b4c2e8e8a86f65bd533c6/f0097b0fd89f6a12688964ae175e52f36b2a04f96f2a014dc26b8ccb53a26a78.png',
      imageIcon2: 'https://liblibai-online.liblib.cloud/public/xingliu.jpg',
      versionDetail: {
        baseType: 'FLUX.1',
        name: 'Star-3',
        modelId: 16932777,
        modelType: 'checkpoint',
        modelUuid: '8b86d942adc241228900c7c5f0a47ad9',
        versionId: 18592945,
        versionIdInpaint: 18532056,
        uuid: 'eaac694155ec464e8120207f555b054a',
        vae: '',
        samplerMethod: '1',
        samplingSteps: 30,
      },
    },
    {
      id: 'base_checkpoint_flux1',
      displayName: '基础模型F.1',
      imageUrl:
        'https://liblibai-online.liblib.cloud/img/c86b535ec32892da5e6cfa5417ba1da5/e4958f18cbd9d40d32a13718a9beb4312303850ce0d6872d27a3d4eb1c2bef6e.jpg',
      // 'https://liblibai-online.liblib.cloud/img/578805fc077649849d0dbf46ed199c8c/9b826de9cf6fe7eb96d861ddf2f51dd6c54c29835236cc0770a5f19ad6140933.png',
      versionDetail: {
        name: 'F.1基础算法模型',
        baseType: 'FLUX.1',
        modelId: 2270871,
        modelType: 'checkpoint',
        modelUuid: '488cd9d58cd4421b9e8000373d7da123',
        versionId: 2295774,
        versionIdInpaint: 18532056,
        uuid: '412b427ddb674b4dbab9e5abd5ae6057',
        vae: '',
        samplerMethod: '1',
        samplingSteps: 30,
      },
    },

    {
      id: 'portrait',
      displayName: '人像摄影F.1',
      imageUrl:
        'https://liblibai-online.liblib.cloud/img/3158b1962c5b4c2e8e8a86f65bd533c6/9e927b570f43d5e983ff8c506177f1ea09be18f6577c533c4de858033c4631e1.png',
      versionDetail: {
        baseType: 'FLUX.1',
        name: 'AWPortrait FL',
        modelType: 'checkpoint',
        modelId: 2490466,
        modelUuid: 'baa0dc46adb34547860a17a571065c9d',
        versionId: 2516926,
        versionIdInpaint: 18532056,
        uuid: '287ef6222ae14d089bff7a2a7c4b6a9b',
        vae: '',
        samplerMethod: '1',
      },
    },
    {
      id: 'base_checkpoint_xl',
      displayName: '基础模型XL',
      imageUrl:
        'https://liblibai-online.liblib.cloud/img/eb248b2879f040a48d0e4e504fd5ca73/c034970f08058077b118d5b3298123791de457f4034181c6241d2426c04cec46.jpeg',
      versionDetail: {
        baseType: 'SD XL',
        name: 'DreamShaper XL1.0',
        modelId: 20999,
        modelType: 'checkpoint',
        modelUuid: '4f9d68642b024d0aa0cdcafb0052af89',
        versionId: 27161,
        uuid: 'b803cf48854646ee8f0ed1fad17009b5',
        vae: '',
        samplerMethod: '15',
      },
    },
    {
      id: 'photography',
      displayName: '写实摄影XL',
      imageUrl:
        'https://liblibai-online.liblib.cloud/img/3158b1962c5b4c2e8e8a86f65bd533c6/d97d6bf4f75b7af0f57953836b9e5074976c9b790df1a8712db48acb3d8e2000.png',
      versionDetail: {
        baseType: 'SD XL',
        name: 'LEOSAM HelloWorld 新世界 | SDXL大模型',
        modelId: 24413,
        modelType: 'checkpoint',
        modelUuid: '506c46c91b294710940bd4b183f3ecd7',
        versionId: 1890038,
        uuid: 'aeed3bb1cdcb40c098e6f5011aa6d5cb',
        vae: '',
        samplerMethod: '15',
      },
    },
    {
      id: 'anime',
      displayName: '动漫游戏 XL',
      imageUrl:
        'https://liblibai-online.liblib.cloud/img/3158b1962c5b4c2e8e8a86f65bd533c6/e609c59ace633dd8c58f79acba876c63a6aeb4af582b7d4ead18b889f5ced001.png',
      versionDetail: {
        name: 'Normal anime_XL',
        baseType: 'SD XL',
        modelId: 1831734,
        modelType: 'checkpoint',
        modelUuid: '20d280af923846bfa436cd759883d7ef',
        versionId: 1853033,
        uuid: '2b39519a44ff4ea99a69d5c0477c654a',
        vae: '',
        samplerMethod: '15',
      },
    },
    {
      id: 'illustration',
      displayName: '插画设计XL',
      imageUrl:
        'https://liblibai-online.liblib.cloud/img/3158b1962c5b4c2e8e8a86f65bd533c6/89cafd4e1d4fa7e2f05f546ba24f69a264b6b4547adedbb5c79d9943051ae064.png',
      versionDetail: {
        name: 'LEOSAM AIArt 兔狲插画 SDXL大模型',
        baseType: 'SD XL',
        modelId: 347406,
        modelType: 'checkpoint',
        modelUuid: 'b2abe174c89940cb90cc4b02d1a5bbc6',
        versionId: 481980,
        uuid: 'f622ceb656c348ce9b08729d8fc2ae42',
        vae: '',
        samplerMethod: '15',
      },
    },
    {
      id: '3d',
      displayName: '3D立体XL',
      imageUrl:
        'https://liblibai-online.liblib.cloud/img/3158b1962c5b4c2e8e8a86f65bd533c6/0da97b1fff05a90828d129d065b8915b1c31c21579143231f1cf4780f339add1.png',
      versionDetail: {
        name: 'Samaritan 3d Cartoon',
        baseType: 'SD XL',
        modelId: 141723,
        modelType: 'checkpoint',
        modelUuid: '6228adb132b149e29ae046ccd01e5612',
        versionId: 151367,
        uuid: '613809f646f2402c8cdd5954644f0896',
        vae: '',
        samplerMethod: '15',
      },
    },
    {
      id: 'cg',
      displayName: 'CG幻想XL',
      imageUrl:
        'https://liblibai-online.liblib.cloud/img/3158b1962c5b4c2e8e8a86f65bd533c6/8004397dffa01bc5b18764e72cd07466e4cb29f4863cd6807b042a3dd586ae0e.png',
      versionDetail: {
        name: 'DreamShaper XL1.0',
        baseType: 'SD XL',
        modelId: 20999,
        modelType: 'checkpoint',
        modelUuid: '4f9d68642b024d0aa0cdcafb0052af89',
        versionId: 27162,
        uuid: '686b30e67ee7489abfdb5d37e30a0f04',
        vae: '',
        samplerMethod: '15',
      },
    },
    {
      id: 'architecture',
      displayName: '空间建筑XL',
      imageUrl:
        'https://liblibai-online.liblib.cloud/img/3158b1962c5b4c2e8e8a86f65bd533c6/e1bf35dd8f72cbafeeb44003c13a369660972980a3a41dd52741b6937f69f694.png',
      versionDetail: {
        name: '老王_archi_XL',
        baseType: 'SD XL',
        modelId: 2157552,
        modelType: 'checkpoint',
        modelUuid: 'b743adf8418844aaa0a01e377cb70d59',
        versionId: 2181492,
        uuid: '0444f77f29bc4e4890df87f62d1fffc6',
        vae: '',
        samplerMethod: '15',
      },
    },
    {
      id: 'ecommerce',
      displayName: '电商视觉XL',
      imageUrl:
        'https://liblibai-online.liblib.cloud/img/3158b1962c5b4c2e8e8a86f65bd533c6/4c18b3c5c09aed2c2f462262a68d511bd0e346722cd80cab1e6fe8ad06e3dd4b.png',
      versionDetail: {
        baseType: 'FLUX.1',
        modelType: 'checkpoint',
        name: '产品写实｜F.1简朴归真-电商',
        modelId: 2446466,
        modelUuid: '7a8ac5d326f24e04b887abc90e59ffa3',
        versionId: 2472697,
        uuid: '482888bc17374beda48b74532cf74668',
        vae: '',
        samplerMethod: '1',
      },
    },
  ],
};

export const presetCheckpoints = config.env === 'aws' ? _presetCheckpoints.shakker : _presetCheckpoints.liblib;

export const presetCheckpointsMap = Object.fromEntries(presetCheckpoints.map((item) => [item.id, item]));
